import { createSlice } from '@reduxjs/toolkit';
import { getMachineListApi } from '@custom/rtk-apis/machine/getMachineList';

const getMachineListApiSlice = createSlice({
    name: 'getMachineListApiSlice',
    initialState: {
      machinePayload: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      reset: (state) => {
        state.machinePayload = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(getMachineListApi.getAllMachineListApi.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(getMachineListApi.getAllMachineListApi.fulfilled, (state, action) => {
          state.machinePayload = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(getMachineListApi.getAllMachineListApi.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });

  export default getMachineListApiSlice.reducer;
  export const { reset } = getMachineListApiSlice.actions
